import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import {
	DynamicFormService,
	IDynamicFormSubmitPayload,
	IDynamicFormSubmitResponse,
} from 'src/app/user-identification/services/dynamic-form.service';

/** Stub local para sandbox /models/form sin back NIF-209. */
@Injectable()
export class FormModelDynamicFormService extends DynamicFormService {
	public override submit(
		_operationUuid: string,
		payload: IDynamicFormSubmitPayload,
	): Observable<{ data: IDynamicFormSubmitResponse }> {
		const currentStep = payload.complete ? undefined : (payload.responses?.length ?? 0) + 1;
		return of({
			data: {
				uuid: 'form-model-filled-mock',
				current_step_order: currentStep,
			},
		});
	}
}
